import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { DeviceInfo } from '@capacitor/device/dist/esm/definitions';
import { isCordova } from 'utils/platform';
import { create } from 'zustand';

type DeviceInfoState = {
  deviceInfo: DeviceInfo | null;
  init: () => Promise<void>;
  setDeviceInfo: (deviceInfo: DeviceInfo) => void;
};
export const useDeviceInfoStore = create<DeviceInfoState>()((set) => ({
  deviceInfo: null,
  init: async () => {
    if (!isCordova()) {
      return;
    }
    if (!Capacitor.isPluginAvailable('Device')) {
      return;
    }
    try {
      const deviceInfo = await Device.getInfo();
      set({ deviceInfo });
    } catch (error) {
      console.error('Failed to get device info:', error);
    }
  },
  setDeviceInfo: (deviceInfo) => {
    set({ deviceInfo });
  },
}));
